export var PlayByPlayIncidentTypes;
(function (PlayByPlayIncidentTypes) {
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["Possesion"] = 1] = "Possesion";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["ThrowIn"] = 2] = "ThrowIn";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["GoalKick"] = 3] = "GoalKick";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["Corner"] = 4] = "Corner";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["FreeKick"] = 5] = "FreeKick";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["Goal"] = 6] = "Goal";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["YellowCard"] = 7] = "YellowCard";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["ShotOnGoal"] = 8] = "ShotOnGoal";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["PenaltyKick"] = 13] = "PenaltyKick";
    PlayByPlayIncidentTypes[PlayByPlayIncidentTypes["RedCard"] = 15] = "RedCard";
})(PlayByPlayIncidentTypes || (PlayByPlayIncidentTypes = {}));
//# sourceMappingURL=PlayByPlayIncidentTypes.js.map